import { render, staticRenderFns } from "./CallFailCountStatisticsPage.vue?vue&type=template&id=532edd44&scoped=true&"
import script from "./CallFailCountStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./CallFailCountStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532edd44",
  null
  
)

export default component.exports